import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { addNewTake } from "../../app/slices/TrainingSlice";
import { CreateTransition } from "../../models/interactions/Transition";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";

export function useAddTake3D() {
  const dispatch = useDispatch();
  const { getNewKey } = useTrainingLocalization();

  const addTake = useCallback(() => {
    dispatch(addNewTake({ transition: CreateTransition(getNewKey()) }));
  }, [dispatch, getNewKey]);

  return { addTake } as const;
}
